import { Injectable } from '@angular/core';
import { NgModel } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class AssetManagerCrossValidationService {
  isAssetManagerRequired(assetManagerReferenceId?: string | null): boolean {
    const val = assetManagerReferenceId || '';
    return val.trim().length > 0;
  }

  isAssetManagerReferenceIdRequired(assetManagerSystemUserName?: string | null): boolean {
    const val = assetManagerSystemUserName || '';
    return val.trim().length > 0;
  }

  syncCrossRequired(
    assetManagerSystemUserName: string | undefined,
    assetManagerReferenceId: string | undefined,
    assetManagerCtrl?: NgModel,
    assetManagerReferenceIdCtrl?: NgModel,
  ): void {
    const am = (assetManagerSystemUserName || '').trim();
    const ref = (assetManagerReferenceId || '').trim();

    if (!am && !ref) {
      assetManagerCtrl?.control.setErrors(null);
      assetManagerReferenceIdCtrl?.control.setErrors(null);
    }
    assetManagerCtrl?.control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    assetManagerReferenceIdCtrl?.control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
  }
}
